import React, {useContext, useState} from 'react'
import {App, Video, VideoContext} from 'src/layouts'
import {VideoContent, VideoPlayer} from 'src/components'
import {Request} from 'eyecons-requests'
import {NextPageContext} from "next";
import {Components} from 'eyecons-components'
import Head from "next/head";

export default function VideoDetail({isPreview = false}: { isPreview?: boolean }) {
    const {video} = useContext(VideoContext)
    const hasPayment = isPreview ? false : video.price && video.price.enabled ? true : video.has_public_plans
    const [paid, setPaid] = useState(!hasPayment)

    const description = video.description || `Bekijk ${video.title} van ${video.channel.label} op Eyecons.com`

    return (
        <>
            <Head>
                <title>{video.title} - Eyecons</title>
                <meta name={'description'} content={description}/>
                <meta name="apple-itunes-app" content={`app-id=6451410028, app-argument=eyecons://VideoPlayerScreen/videoId/${video.id}`} />

                <meta name={'twitter:card'} content={'summary_large_image'}/>
                <meta name={'twitter:image'} content={video.thumbnail}/>
                <meta name={'twitter:title'} content={video.title + ' - Eyecons'}/>
                <meta name={'twitter:description'} content={description}/>

                <meta property={'og:url'} content={`${process.env.NEXT_PUBLIC_SITE_URL}/videos/${video.url}`}/>
                <meta property={'og:type'} content={'video'}/>
                <meta property={'og:title'} content={video.title + ' - Eyecons'}/>
                <meta property={'og:description'} content={description}/>
                <meta property={'og:image'} itemProp={'image'} content={video.thumbnail_large}/>
            </Head>
            <div className={'max-w-[1522px] mx-auto px-4 sm:pt-4'}>
                <div className={'flex flex-col md:flex-row gap-8'}>
                    <div className={'w-full md:w-3/5 lg:w-2/3'}>
                        <VideoPlayer
                            paid={paid}
                            setPaid={setPaid}
                            hasPayment={hasPayment}
                        />

                        <div className={'pt-hd md:pt-8 mt-[30px] sm:mt-[40px] md:mt-0'}>
                            <VideoContent paid={paid}/>
                        </div>
                    </div>

                    <div className={'w-full md:w-2/5 lg:w-1/3 pb-12'}>
                        <Components.Ads.Ad className={'video-recommended-ads'} type={'rectangle-halfpage'}/>

                        {
                            video?.recommended?.clubs && video.recommended.clubs.length > 0 && <div className={'mb-4'}>
                                <Components.Texts.Heading type={'h5'} className={'mb-4'}>
                                    Wedstrijdvideo’s
                                </Components.Texts.Heading>

                                <div className={'flex flex-col gap-2'}>
                                    {video?.recommended?.clubs.map((video, index) => {
                                        return <Components.Videos.Card variant={'fixed'} key={index} video={video}/>;
                                    })}
                                </div>
                            </div>
                        }

                        {
                            video?.recommended?.competition && video.recommended.competition.length > 0 && <div>
                                <Components.Texts.Heading type={'h5'} className={'mb-4'}>
                                    Aanbevolen voor jou
                                </Components.Texts.Heading>

                                <div className={'flex flex-col gap-2'}>
                                    {video?.recommended?.competition.map((video, index) => {
                                        return <Components.Videos.Card variant={'fixed'} key={index} video={video}/>;
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}


VideoDetail.getLayout = function getLayout(page: React.ReactElement) {
    return (
        <App>
            <Video video={page.props.video}>
                {page}
            </Video>
        </App>
    )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
    const slug = ctx.query.slug as string
    const id = slug.split('-').pop()

    const video = await Request.fromApi('backend', {public: true}).get(`/videos/${id}`, {
        with_recommended: true,
        videos_count: true
    })

    if (!video.data) {
        return {
            notFound: true
        }
    }

    return {
        props: {
            video: video.data
        }
    }
}
